import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import score from 'src/helper/score'
import { unix2date6 } from 'src/helper/time'
import { history } from 'src/core/router'
import 'swiper/swiper-bundle.min.css'
import http from 'src/helper/http'
import uploadImg from '../../../tools/uploadImage'
import ReminderBtn from 'src/component/RuleButton'
import Message from 'src/component/Message'
import vs from "src/helper/vconsole.js";
import fileType from 'src/helper/fileType'
import {  chooseImage, uploadFile } from 'src/helper/webviewFun'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    lang: langM.ar,
    language: 'en',
    userInfo: {},
    rommValues:'',
    uploadpic:[],
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    console.log('admin-control-user', this.props.location.query)
    this.setState({
      uid: uid,
      gid:this.props.location.query.gid,
    })

    // console.log(uid, 'uid')
    await this.getRoomInfo(this.props.location.query.gid)
  }

  // 初始化/接口请求初始化

  getRoomInfo = async (uid) => {
    let res = await http.post('/web/search/user/room', {keyword:uid+''})
    console.log(res)
    if (res.code == 0 && res.res.rooms[0]) {
      this.setState({ userInfo: res.res.rooms[0] })
    }
  }

  async get132(aa) {
    console.log("选择图片")

    let map = {
      count: 1, //可以选择的最多数量
      sizeType: 'compressed', //大小压缩 original/compressed
      mp4Enabled: false //是否可以选择mp4，true等于可以同时选mp4和图片
    }
    console.log('选择图片提交的参数', map)
    chooseImage(map, (d) => { //只能把回调放在这里，因为是异步回调，无法改成async await
      console.log('选择图片回调', d)
      this.setState({
        pic: d || []
      })
     this.get16(d)
    })
   
    return
  }
   get16=async(url)=> {
    console.log("pic的图片数量" + url.length)
    if (url.length > 0) {
      let req = []
      for (let i = 0; i < url.length; i++) {
        req.push({
          filePath: url[i].path,
          fileType: fileType.get(url[i].path)
        })
      }
      // console.log("选择的图片数量" + req.length)
      console.log("调用dsBridge上传前", req)

      console.log('上传之前的图片地址')
        for (let i = 0; i < req.length; i++) {
          console.log(req[i].filePath+" 文件类型 " + req[i].fileType)
        }

      uploadFile(req, (d) => {
        console.log('上传之后的图片地址',d)
        this.setState({
          uploadpic: d || []
        })
        // for (let i = 0; i < d.length; i++) {
        //   console.log(d[i].filePath+" 对应上传网址是 " + d[i].url)
        // }

        // uploadpic

      })
    } else {
      console.log("没有选择图片")
    }
  }

  showGoldModle = (open, close) => {
    let { lang } = this.state
    let {type} = this.state
    return (
      <div
        className="gold-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.banText}</div>
        {/* <div className="gold-modle-body">
          <div className="amount">
            <div className="amout-left">{lang.rechargeAmountText}</div>
            <div className="amout-rigit">${sendPrice/100}</div>
          </div>
          <div className="amount">
          { type=='ruby' && <div className="amout-left">{lang.getRubiesText}</div>}
            { type!='ruby' && <div className="amout-left">{lang.getCoinsText}</div>}
            <div className="amout-rigit">{sendGold - this.props.degold}</div>
          </div>

        </div> */}
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.no}
          </div>
          <div
            className="modle-confirm"
            onClick={() => this.resetRoomInfo()}
          >
            {lang.yes}
          </div>
        </div>
      </div>
    )
  }
  showModle = (open, close) => {
    let { lang } = this.state
    let {type} = this.state
    return (
      <div
        className="gold-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.removeText}</div>
        {/* <div className="gold-modle-body">
          <div className="amount">
            <div className="amout-left">{lang.rechargeAmountText}</div>
            <div className="amout-rigit">${sendPrice/100}</div>
          </div>
          <div className="amount">
          { type=='ruby' && <div className="amout-left">{lang.getRubiesText}</div>}
            { type!='ruby' && <div className="amout-left">{lang.getCoinsText}</div>}
            <div className="amout-rigit">{sendGold - this.props.degold}</div>
          </div>

        </div> */}
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.no}
          </div>
          <div
            className="modle-confirm"
            onClick={() => this.removeRoomList()}
          >
            {lang.yes}
          </div>
        </div>
      </div>
    )
  }
  selectMytype = (e) => {
    console.log(e.target.value)
  }
  selectTime = (e) => {
    console.log(e.target.value)
  }

  resetRoomInfo = async()=>{
    let {rommValues, uid ,imgUrl,lang,gid,uploadpic} = this.state
    //if (rommValues=='') return
    let res = await http.post('/web/group/reset',{gid:gid*1,reason:rommValues,pic:uploadpic[0]})
    if (res.code == 0) {
      this.refs.msg.show(lang.successful)
    }else if (res.code == 9999 ) {
      this.refs.msg.show(lang.nohad)
    }
  }

  //
  removeRoomList = async()=>{    
    let {rommValues, uploadpic ,imgUrl,lang,gid} = this.state
   // 暂时不让封禁房间= 500
    // let res = await http.post('/web/room/backlistadd',{gid:gid*1,reason:rommValues,pic:uploadpic[0]})
    // if (res.code == 0) {
    //   this.refs.msg.show(lang.successful)
    // }else if (res.code == 9999 ) {
      this.refs.msg.show(lang.nohad)
    // }
  }

  //
  clearImg = () => {
    this.setState({
      uploadpic:[],
    })
  }

  setRoom= async()=>{

  }
  setValue = (e)=>{
     this.setState({rommValues:e.target.value})
  }
  render() {
    let { lang, userInfo, pic } = this.state
    return (
      <div className="bane-reset-room">
        <div className="user-card">
          <div className="set-user-info">
            <div className="avatar-root">
              <img className="avatar-img" src={userInfo.logourl}></img>
            </div>
            <div className="user-info">
              <div className="user-info-top">
                <div className="top-text">{userInfo.name}</div>
              </div>
              <div className="user-info-top">
                <div className="top-text">{userInfo.announcement}</div>
              </div>
              <div className="user-info-buttom">ID: {userInfo.gid}</div>
            </div>
          </div>
        </div>
        <div className="text-title">{lang.reason}</div>
        <div className="reason-root">
          <div className="input-root">
            <textarea
              className="reason-root-input"
              name="story"
              rows="3"
              cols="34"
              placeholder={lang.poaloder}
              maxLength={100}
              onChange={(e)=>this.setValue(e)}
            ></textarea>
          </div>
          <div className="upload-root">
             {this.state.uploadpic.length>0 && <img src={this.state.uploadpic[0]} className='upload'></img>}
             {this.state.uploadpic.length>0 && <img src='/img/app/admin-control-panel/delect_icon.png' className='del-icon' onClick={this.clearImg}></img>}
             {!this.state.uploadpic.length>0 && <div className='text-title'>upload</div>}
             {!this.state.uploadpic.length>0 && <div
              id="upload"
              className="upload"
              onClick={()=>this.get132()}
            />}
          
            
          </div>
        </div>
        <div className="text-title">{lang.reset}</div>
        {/* <div className="ban-reset" onClick={this.setRoom}>Reset room data</div> */}
        <ReminderBtn
                lang={this.state.lang}
                slotButtonComp={() => {
                  return  <div className="ban-reset" onClick={this.setRoom}>{lang.resetRoomData}</div>
                }}
                slotContentComp={this.showGoldModle}
              />
        <ReminderBtn
                lang={this.state.lang}
                slotButtonComp={() => {
                  return  <div className="ban-reset">{lang.removeList}</div>
                }}
                slotContentComp={this.showModle}
              />

<Message ref="msg" desc={this.state.desc} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/admin-control/bane-reset-room/index.js